import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import 'rxjs/add/operator/map';
import { GraphConfigModel } from '../../../common/viewModels/GlobalRegistry/UnitsModel';
import { GraphTempModel, CharacteristicsDDLModel } from '../../../common/viewModels/GlobalRegistry/GraphTempModel';
import { AmplifyService } from '../../../common/amplify-service';
declare var $: any;

@Component({
    selector: 'graphtemplates',
    templateUrl: './graphtemplist.component.html',
    styleUrls: ['./graphtemplist.component.scss']
})
export class GraphTemplateComponent implements OnInit {
    GraphTemplateForm: FormGroup;
    GraphConfigForm: FormGroup;
    GraphSrchForm: FormGroup;
    lstCharacteristics: CharacteristicsDDLModel[];
    graphTypes: any;
    isSubmitted: boolean = false;
    isTempSubmitted: boolean = false;
    tempFormValid: boolean = false;
    id: number;
    searchFields: GraphTempModel = new GraphTempModel();
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    name: any;
    graphConfigs = [];
    graphTemplateId: number;
    newGraphConfig: GraphConfigModel = new GraphConfigModel();
    mainComponent: any;

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService, private _validationService: ValidationService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService, private _amplifyService: AmplifyService) {

        this.mainComponent = _mApp;

    }
    ngOnInit() {
        this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.GraphSrchForm = this._formBuilder.group({
            Name: ['']
        });
        this.CreateForm();
        this.CreateGraphConfigForm();
        this.GetCharacteristicsForDDL();
        this.GetListOfGraphTypes();
        this.BindStaticSearchData();
        this.GetDataFromAmpliy();
        this.setPage(this.pager);
        this.ClearDataInAmplify();
    }

    CreateForm() {
        this.GraphTemplateForm = this._formBuilder.group({
            GraphTemplateTypeId: [0],
            Name: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(50)])],
        });
    }

    CreateGraphConfigForm() {
        this.GraphConfigForm = this._formBuilder.group({
            GraphConfigId: [0],
            GraphTemplateTypeId: [0],
            GraphDesc: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(50)])],
            CharIds: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            GraphTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],

        });
    }

    OnSearchSubmit() {
        this.pager.pageIndex = 0;
        this.ConstructSearchData();
        this.setPage(this.pager);
    }

    ConstructSearchData() {
        let searchDto = this.GraphSrchForm.value;
        this.searchFields.Name = searchDto.Name;
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetGraphTempList(page);
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._pagerService.globalPageSize;
    }

    GetCharacteristicsForDDL() {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetCharacteristics)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    if (data.json().Result != null)
                        this.lstCharacteristics = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    //this._toastrService.error(error.json().Result, '');
                }
            );
    }

    GetListOfGraphTypes() {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfGraphTypes)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    if (data.json().Result != null)
                        this.graphTypes = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    //this._toastrService.error(error.json().Result, '');
                }
            )
    }

    GetGraphTemplateById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetGraphTemplateById + id)
            .subscribe(
                m => {
                    this._mApp.HideLoader();
                    if (m.json().Result != null) {
                        this.GraphTemplateForm.setValue(m.json().Result);
                    }
                }, error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    GetGraphTempList(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.GetListofGraphTemplates, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    var response = res.json();
                    this.length = response.PageResult.TotalRecords;
                    this.pagedItems = response.Result;
                    this.isNoRecords = !(response.Result.length > 0);
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    DeleteGraphTemplate(id: any) {
        this.id = id;
    }

    DeleteGraphTemplateById(id: number) {
        this.SaveDataInAmplify();
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteGraphTemplateById + id)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    this._toastrService.success(res.json().Result, '');
                    this.GetDataFromAmpliy();
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    IsFormValid(lst: any) {
        let valid: boolean = false;
        for (let item of lst) {
            if (item.GraphDesc != null && item.GraphDesc != "" && item != undefined &&
                item.GraphTypeId > 0 && item.charIds.length > 0) {
                valid = true;
            }
            else
                return valid = false;
        }
        return valid;
    }

    onGraphConfigSubmit() {
        this.isTempSubmitted = true;
        if (this.newGraphConfig.GraphDesc != null && this.newGraphConfig.GraphDesc != "" && this.newGraphConfig.GraphDesc != undefined &&
            this.newGraphConfig.GraphTypeId > 0 && this.newGraphConfig.charIds.length > 0) {
            this.newGraphConfig.GraphTemplateTypeId = this.graphTemplateId;
            this.newGraphConfig.GraphOrderId = this.graphConfigs.length + 1;
            this.graphConfigs.push(this.newGraphConfig);
        }
        if (this.IsFormValid(this.graphConfigs)) {
            this._mApp.ShowLoader();
            this._http.post(this._appUrl.UpsertGraphConfig, this.graphConfigs)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        $('#graphConfigModel').modal('toggle');
                        this.newGraphConfig = new GraphConfigModel();
                        this._toastrService.success(data.json().Result);
                    },
                    error => {

                        this._mApp.HideLoader();
                        this.graphConfigs.splice(-1, 1);
                        this._toastrService.error(error.json().Result);
                    }
                )
        }
    }

    onSubmit() {
        this.isSubmitted = true;
        if (this.GraphTemplateForm.valid) {
            let graphTemplate = this.GraphTemplateForm.value;
            this._mApp.ShowLoader();
            if (graphTemplate.GraphTemplateTypeId == null || graphTemplate.GraphTemplateTypeId == 0) {
                graphTemplate.GraphTemplateTypeId = 0;
            }
            this._http.post(this._appUrl.UpsertGraphTemplates, graphTemplate)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result, '');
                        $('#graphTempModel').hide();
                        this.setPage(this.pager);
                        this.Clear();
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result, '');
                    }
                );
        }
    }

    Clear() {
        this.GraphTemplateForm.reset();
        //this.CreateForm();
    }

    OnReset() {
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.GraphSrchForm.reset();
        this.searchFields.Name = '';
        this.setPage(this.pager);
    }

    SaveDataInAmplify() {
        this._amplifyService.SetStorage('graphTmpltsList', this.GraphSrchForm.value);
        this._amplifyService.SetStorage('graphTmpltsList_PageNo', this.pager.pageIndex);
        this._amplifyService.SetStorage('graphTmpltsList_PageSize', this.pager.pageSize);
    }


    GetDataFromAmpliy() {
        let storedData = this._amplifyService.GetStorage('graphTmpltsList');
        if (storedData != undefined && storedData != null) {
            this.GraphSrchForm.setValue(storedData);
            this.ConstructSearchData();
        }
        // let savedPageSize = this._amplifyService.GetStorage('graphTmpltsList_PageSize');
        // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pagerService.pageSize;
        let pageIndex = this._amplifyService.GetStorage('graphTmpltsList_PageNo');
        if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
            this.pager.pageIndex = pageIndex;
        else
            this.pager.pageIndex = 0;
    }

    ClearDataInAmplify() {
        this._amplifyService.ClearStorage('graphTmpltsList');
        this._amplifyService.ClearStorage('graphTmpltsList_PageNo');
        this._amplifyService.ClearStorage('graphTmpltsList_PageSize');
    }

}
